import { defineComponent, ref, onMounted, watch } from 'vue'
declare const jsonTree: any;
const JsonDom = defineComponent((props: any) => {
    const $el: any = ref()
    const setData = () => {
        let _json = props.data;
        if (typeof(props.data) == 'string') {
            try {
                _json = JSON.parse(props.data)
            } catch (error) {
                $el.value.innerHTML = props.data;
                return;
            }
        } 
        $el.value.innerHTML = '';
        jsonTree.create(_json, $el.value);
    }
    onMounted(() => {
        setData()
    })
    watch(() => props.data, () => {
        setData()
        console.log('xxxxxxx')
    }, {deep: true})
    return () => <div style='background: #f5f5f5;padding: 10px;border-radius: 4px;' ref={$el}>

    </div>
})
JsonDom.props = {
    data: [Object,String,Array]
}
const ApiInfo = defineComponent((props: any) => {


    return () => <div style='padding: 10px;height:100%;box-sizing:border-box;'>
        <div style='width:100%;height:100%;padding: 10px;box-sizing:border-box;overflow:auto'>
            <div style='font-size: 18px;padding: 10px 10px;background: #fff;margin-bottom: 10px;border-radius:4px;'>
                <div style='display:inline-block;width:80px'>url:</div> &nbsp;&nbsp; {props.data.url}
            </div>
            {props.data.query && <div style='font-size: 18px;display:flex;padding: 10px 10px;background: #fff;margin-bottom: 10px;border-radius:4px;'>
                <div style='position:relative;top:12px;width:80px'>query:</div> &nbsp;&nbsp; 
                <div style='flex:1;width:1px;'>
                <JsonDom data={props.data.query} />
                </div>
            </div>}
            {props.data.fields && <div style='font-size: 18px;display:flex;padding: 10px 10px;background: #fff;margin-bottom: 10px;border-radius:4px;'>
                <div style='position:relative;top:12px;width:80px'>fields:</div> &nbsp;&nbsp; 
                <div style='flex:1;width:1px;'>
                <JsonDom data={props.data.fields} />
                </div>
            </div>}
            {props.data.headers && <div style='font-size: 18px;display:flex;padding: 10px 10px;background: #fff;margin-bottom: 10px;border-radius:4px;'>
                <div style='position:relative;top:12px;width:80px'>headers:</div> &nbsp;&nbsp; 
                <div style='flex:1;width:1px;'>
                <JsonDom data={props.data.headers} />
                </div>
            </div>}
            {props.data.result && <div style='font-size: 18px;display:flex;padding: 10px 10px;background: #fff;margin-bottom: 10px;border-radius:4px;'>
                <div style='position:relative;top:12px;width:80px'>result:</div> &nbsp;&nbsp; 
                <div style='flex:1;width:1px;'>
                    <JsonDom data={props.data.result} />
                </div>
            </div>}
        </div>
    </div>

})
ApiInfo.props = {
    data: Object
}

export default ApiInfo;